import "bootstrap/dist/css/bootstrap.min.css";
import * as React from "react";
import ThemeProvider from "./src/context/themeContext";

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
);
